module.exports = __webpack_public_path__ + "static/csc-7-ab48a8b612b5274ea1ae0fe7efb999b0.jpg";